export interface OverlapWarningBody {
  warning: "overlap"
  message: string
  overlapPct: number
  proceed: false
}

// The 409 overlap response has no `error` field (it's `{warning, message,
// overlapPct, proceed}`), so ApiError's flattened `.message` degrades to a
// bare "HTTP 409" — inspect the raw error's `status`/`body` instead so we
// can show the real message and offer "Import anyway" (M4). Duck-typed
// rather than `instanceof ApiError` — test files' `mock.module("@/lib/api",
// ...)` commonly don't export the real ApiError class (see use-learning.ts
// #129), and a named import of it would hard-fail under those mocks.
// `body` is undefined when the response wasn't JSON (e.g. a proxy's HTML
// 502 — Signet then says "Request failed (502 Bad Gateway)"), so never
// assume it exists.
export function overlapWarningFrom(err: unknown): OverlapWarningBody | null {
  if (!(err instanceof Error)) return null
  const { status, body } = err as { status?: unknown; body?: unknown }
  if (status !== 409) return null
  if (typeof body !== "object" || body === null) return null
  if ((body as { warning?: unknown }).warning !== "overlap") return null
  return body as OverlapWarningBody
}
